var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMasonryBuilder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.88407 6.21213L7.80595 11.5909C7.82817 11.7204 7.88402 11.8418 7.96791 11.9429C8.0518 12.044 8.16078 12.1213 8.28394 12.1671C8.4071 12.2128 8.54013 12.2254 8.66969 12.2036C8.79926 12.1818 8.92082 12.1263 9.0222 12.0428L13.2022 8.60025C13.3036 8.51674 13.3812 8.40806 13.4274 8.28511C13.4736 8.16215 13.4867 8.02922 13.4654 7.89962C13.444 7.77002 13.389 7.64829 13.3059 7.54661C13.2228 7.44494 13.1144 7.36688 12.9916 7.32025L7.88907 5.38275C7.76535 5.33581 7.6314 5.32245 7.50084 5.34401C7.37027 5.36557 7.24774 5.4213 7.14567 5.50553C7.04361 5.58975 6.96565 5.69949 6.9197 5.82359C6.87376 5.94769 6.86147 6.08174 6.88407 6.21213V6.21213Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3164 9.35645L12.2239 11.6727",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.224 11.674C12.3798 11.545 12.5793 11.4809 12.7812 11.4951C12.983 11.5093 13.1716 11.6007 13.3078 11.7503L15.5003 14.159C15.5872 14.2543 15.6539 14.3662 15.6962 14.4881C15.7386 14.6099 15.7556 14.7391 15.7464 14.8678C15.7371 14.9964 15.7018 15.1218 15.6425 15.2364C15.5832 15.3509 15.5012 15.4522 15.4015 15.534V15.534C15.3022 15.6159 15.1872 15.6767 15.0636 15.7128C14.94 15.7489 14.8104 15.7594 14.6826 15.7438C14.5548 15.7282 14.4315 15.6868 14.3202 15.622C14.2089 15.5573 14.112 15.4705 14.0353 15.3672L12.0921 12.7503C11.9721 12.5881 11.9188 12.3861 11.9433 12.1858C11.9679 11.9856 12.0684 11.8024 12.224 11.674V11.674Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75 3.5V0.25H13.25V3.5",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 0.25V3.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 3.5V6.75H0.25V3.5H15.75V6.75H14.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3.5V4.75",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75 6.75V10",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 10H0.25V13.25H6.5",
    stroke: "#464646",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 10V13.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasonryBuilder);
export default __webpack_public_path__ + "static/media/masonry-builder.a2cbe622.svg";
export { ForwardRef as ReactComponent };